import { Fragment } from "react";
import { Link } from "react-router-dom";

const breadcrumbsItems = (breadcrumbItems) => {
  return (
    <Fragment>
      {breadcrumbItems?.map((item, index) => (
        <li
          key={index}
          className={`breadcrumb-item ${item.active && "active"}`}
        >
          {item.label}
        </li>
      ))}
    </Fragment>
  );
};

export default breadcrumbsItems;
